import React, { useContext, useEffect } from 'react'

import { GroupsImagesContext } from '../../domain-repository/GroupsImagesRepository'
import { DomainContext } from '../../domain-repository/DomainRepository'
import { saveSessionEnd } from '../../services/Metrics'
import { session } from '../../load-config'

function StartPage({ history }) {
  const { setKioskAppVersionId, setSessionId } = useContext(DomainContext)

  useEffect(() => {
    localStorage.clear()
    
    // Preserve metricsParams from redirect from brokers and other sources, that were saved from the query params in the url
    const metricsParams = JSON.parse(sessionStorage.getItem('metricsParams'))
    sessionStorage.clear()
    if(metricsParams !== null) {
      sessionStorage.setItem('metricsParams', JSON.stringify(metricsParams))
    }

    if (session.getSessionId()) {
      setSessionId(null)
      saveSessionEnd()
    }
    setKioskAppVersionId(2)
  }, [])

  return (
    <main className="home" onClick={() => history.push('/init')}>
      <div className="home-top text-center pt-4">
        <div className="container">
          <img src={require(`../../assets/images/logo.png`)} alt="" />
        </div>
      </div>
      <div className="home-bottom text-center align-items-center d-flex">
        <div className="container">
          <div>
            <h2>A sua Viagem começa <a><b>Aqui</b></a></h2>
            <h2>Your Journey starts <a><b>here</b></a></h2>
          </div>
        </div>
        <div className='next footer-cta--anim'><img style={{ width: '50px' }} src={require(`../../assets/images/btn-next-2-active.png`)} alt='Next' /></div>
      </div>
    </main>
  )
}

export default StartPage